import { render } from "./IconPreviousItem.vue?vue&type=template&id=77652d5b"
import script from "./IconPreviousItem.vue?vue&type=script&lang=js"
export * from "./IconPreviousItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__